var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e4110d9480e025ae4e3ae84c0d52ce14a53055b0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react@eprezto"]={id:"e4110d9480e025ae4e3ae84c0d52ce14a53055b0"};
      